module.exports = __webpack_public_path__ + "img/full3-min.8d8db047.png";